import '../../css/misc/contactform.css';
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Col, Row } from 'react-bootstrap';
import SignalRService from '../../controllers/SignalRService';
import { changeJanusStatus } from '../../redux/parametersSlice';
import ChatsService from 'src/controllers/ChatController';
import Toastr from '../utils/toastr';
import { setConverastionBookId, setContacts } from 'src/redux/interactionsSlice';
import { channelsKeys } from '../utils/consts';
class AddressBookFormCall extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contactId: -1,
            contactForm: "",
            formState: "new"
        }

        this.handleMessage = this.handleMessage.bind(this);
        this.setContactUrl = this.setContactUrl.bind(this);
        this.updateContactState = this.updateContactState.bind(this);
        this.toastrRef = React.createRef();
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
        this.updateContactState();
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }
    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.state) !== JSON.stringify(prevState) || JSON.stringify(this.props) !== JSON.stringify(prevProps))
            this.updateContactState();
    }

    updateContactState() {

        let contactId = -1;
        let contactForm = "";
        let hostName = window.location.hostname;
        let state = "new";

        //! TODO: Trampa    
        if (hostName === 'localhost' || hostName === '127.0.0.1')
            hostName = "devomni.fidelitycloud.es";

        if (this.props.contacts.length === 1) {
            contactId = this.props.contacts[0].contactId;
            state = "modify";
        }

        contactForm = `//${hostName}/FidelityForms?campaignId=${this.props.addressBookId}&state=${state}&pin=${this.props.userId}&contactId=${contactId}`;

        if ("chat" === this.props.mode) {

            contactForm += ("&chatguid=" + this.props.interaction.guid)

            switch (this.props.interaction.channel) {
                case channelsKeys.CHAT:
                case channelsKeys.FIDELITY:
                    contactForm += `&phone=${this.props.interaction.phone || ""}&contactMail=${this.props.interaction.email || ""}`;
                    break;
                case channelsKeys.FACEBKOOK:
                    contactForm += `&facebookId=${this.props.interaction.id}`;
                    break;
                case channelsKeys.INSTAGRAM:
                    contactForm += `&instagramId=${this.props.interaction.id}`;
                    break;
                case channelsKeys.WHATSAPP:
                case channelsKeys.SMS:
                case channelsKeys.TELEGRAM:
                    contactForm += `&phone=${this.props.interaction.phone || ""}`;
                    break;
                case channelsKeys.MAIL:
                    contactForm += `&email=${this.props.interaction.email || ""}`;
                    break;
                default:
                    break;
            }

        } else {
            contactForm += `&phone=${this.props.party || ""}`;
        }

        this.setState({
            contactId: contactId,
            contactForm: contactForm,
            formState: state
        });
    }

    setContactUrl() {

        var hostName = window.location.hostname;
        //! TODO: Trampa
        if (hostName === 'localhost' || hostName === '127.0.0.1')
            hostName = "devomni.fidelitycloud.es";
        if (this.props.contacts !== null && this.props.contacts.length > 0) {
            this.setState({
                contactId: this.props.contacts[0].contactId,
                contactForm: "//" + hostName + "/FidelityForms?campaignId=" + this.props.addressBookId + "&state=modify&pin=" + this.props.userId + "&contactId=" + this.props.contacts[0].contactId
            });
        }

    }

    handleMessage(event) {
        console.log("AddressBookFormCall handleMessage: ", event.data);

        var hostName = window.location.hostname;
        //! TODO: Trampa
        if (hostName === 'localhost' || hostName === '127.0.0.1')
            hostName = "devomni.fidelitycloud.es";

        if (event.data.Method === "SetFormChange" && event.data.Status === "ABCLOSE" && this.state.formState !== "new") {
            //this.setState({ contactForm: "" });
            setTimeout(this.setContactUrl, 500);
        }

        //Esto solo se ejecuta en caso de NEW CONTACT
        if (event.data && "SetBookId" === event.data.Method && event.data.BookId !== undefined && event.data.BookId !== null && this.state.contactId === -1) {
            if ("chat" === this.props.mode && event.data.ChatGUID !== null && event.data.ChatGUID.length > 0) {
                ChatsService.setConverastionBookId({
                    guid: this.props.interaction.guid,
                    contactId: event.data.BookId
                }, res => {
                    if (res !== "ok") {
                        this.toastrRef.current.setType("error");
                        this.toastrRef.current.setMessage(this.props.t(res));
                        this.toastrRef.current.show();
                    } else {
                        this.props.setConverastionBookId(event.data.BookId);
                        this.toastrRef.current.setType("success");
                        this.toastrRef.current.setMessage(this.props.t("wassavedsuccessfully"));
                        this.toastrRef.current.show();

                        this.setState({
                            contactId: event.data.BookId,
                            formState: "modify",
                            contactForm: "//" + hostName + "/FidelityForms?campaignId=" + this.props.addressBookId + "&state=modify&pin=" + this.props.userId + "&contactId=" + event.data.BookId
                        });
                    }
                });
            } else {

                if (event.data.ChatGUID === null || (event.data.ChatGUID !== null && event.data.ChatGUID.length === 0)) {
                    SignalRService.associatedContact({
                        "extension": this.props.extension,
                        "userId": this.props.userId,
                        "contactId": parseInt(event.data.BookId)
                    });
                }

            }
        }

        if (event.data.Method === "MakeCallCampRemote") {
            this.props.changeJanusStatus("makeCall");
            SignalRService.makeCallCamp({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "called": event.data.Called,
                "prefix": event.data.Prefix
            });
        }

        // // This reloads contact form on Cancel or Close
        // if (event.data.Method === "SetFormChange" && event.data.Status === "ABCANCEL") {
        //     this.setState({ contactForm: "" });
        //     this.handleMessage({ data: { Method: null } });
        // }
        // if (event.data.Method === "SetFormChange" && event.data.Status === "ABCLOSE") {
        //     setTimeout(() => {
        //         this.setState({ contactForm: "" });
        //         this.handleMessage({ data: { Method: null } });
        //     }, 500);
        // }
    }

    render() {
        return (
            <Row>
                <Col style={{ height: "65vh" }}>
                    <iframe title={this.props.t("contact")} src={`https:${this.state.contactForm} `} width={"100%"} height={"100%"}></iframe>
                    <Toastr ref={this.toastrRef} />
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        addressBookId: state.agent.addressBookId,
        interaction: state.interaction.current,
        party: state.agent.party
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus, setConverastionBookId, setContacts }), withTranslation())(AddressBookFormCall);